import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule, MatIconModule } from '@angular/material';
import { CustomSnackbarContentComponent } from './services/snackbar.service';



@NgModule({
	declarations: [CustomSnackbarContentComponent],
	imports: [CommonModule, MatIconModule, MatButtonModule],
	exports: [],
	entryComponents:[CustomSnackbarContentComponent]
})
export class FinexDesignSystemModule {
	public static forRoot(environment: any): ModuleWithProviders {

		return {
			ngModule: FinexDesignSystemModule,
			providers: [
				{
					provide: 'env', // you can also use InjectionToken
					useValue: environment
				}
			]
		};
	}
}
